'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvailabilityFilter = function () {
    function AvailabilityFilter(showHideDialog, highlightUsedButton) {
        (0, _classCallCheck3.default)(this, AvailabilityFilter);

        this.showHideDialog = showHideDialog;
        this.highlightUsedButton = highlightUsedButton;
        this.dialog = null;
        this.availabilityValueInput = null;
        this.openDialogEvent = null;
        this.operatorSelectSelector = '#availabilityOperatorSelect';
        this.availabilityValueInputSelector = '#availabilityValueInput';
    }

    (0, _createClass3.default)(AvailabilityFilter, [{
        key: 'registerFilterClick',
        value: function registerFilterClick(event) {
            var _this = this;

            this.openDialogEvent = event;
            this.dialog = document.getElementById('facetAvailabilityPopup');
            if (this.dialog) {
                var filterObject = _common2.default.loadObjectFilter();

                this.availabilityValueInput = this.dialog.querySelector(this.availabilityValueInputSelector);
                if (this.availabilityValueInput && filterObject) this.availabilityValueInput.value = parseInt((this.isFilterByCustomAvail() ? filterObject.CustomAvailabilityValue : filterObject.AvailabilityValue) || 1);

                var operatorSelect = this.dialog.querySelector(this.operatorSelectSelector);
                if (operatorSelect && filterObject) {
                    operatorSelect.value = (this.isFilterByCustomAvail() ? filterObject.CustomAvailabilityOperator : filterObject.AvailabilityOperator) || 1;
                    $(operatorSelect).val(operatorSelect.value).trigger('change');
                }
            }

            var stateTitleElement = this.dialog.querySelector('#stateTitle');
            if (stateTitleElement && this.openDialogEvent) {
                stateTitleElement.textContent = this.openDialogEvent.target.textContent;
            }

            var stateIconElement = this.dialog.querySelector('#stateIcon');
            if (stateIconElement && this.openDialogEvent) {
                stateIconElement.className = 'label-icon ' + this.openDialogEvent.target.dataset.facetIcon;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.popup-availability-filter-button')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var availButton = _step.value;

                    if (availButton.clickRegistered) continue;

                    availButton.addEventListener('click', function (event) {
                        _this.filterByDateButtonClick(event);
                    });
                    availButton.clickRegistered = true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(document.querySelectorAll('.popup-availability-cancel-button')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cancelButton = _step2.value;

                    if (cancelButton.clickRegistered) continue;

                    cancelButton.addEventListener('click', function (event) {
                        _this.filterByDateButtonClick(event, true);
                    });
                    cancelButton.clickRegistered = true;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'isFilterByCustomAvail',
        value: function isFilterByCustomAvail() {
            if (!this.openDialogEvent) return false;
            return this.openDialogEvent.target.classList.contains('filter-button-my-state');
        }
    }, {
        key: 'filterByDateButtonClick',
        value: function filterByDateButtonClick(event, isCancel) {
            var filterObject = _common2.default.loadObjectFilter();
            var availabilityOperatorSelect = this.dialog.querySelector(this.operatorSelectSelector);

            if (isCancel) {
                if (this.isFilterByCustomAvail()) {
                    delete filterObject.CustomAvailabilityOperator;
                    delete filterObject.CustomAvailabilityValue;
                } else {
                    delete filterObject.AvailabilityOperator;
                    delete filterObject.AvailabilityValue;
                }

                if (this.highlightUsedButton) this.highlightUsedButton(this.openDialogEvent.target);
            } else {
                if (!availabilityOperatorSelect || !this.availabilityValueInput || !filterObject) return;

                var operator = parseInt(availabilityOperatorSelect.value);
                var value = parseInt(this.availabilityValueInput.value.match(/^[0-9]+$/) || 0);

                if (this.isFilterByCustomAvail()) {
                    filterObject.CustomAvailabilityOperator = operator;
                    filterObject.CustomAvailabilityValue = value;
                } else {
                    filterObject.AvailabilityOperator = operator;
                    filterObject.AvailabilityValue = value;
                }
            }
            var url = _common2.default.setupUpdateSearchUrlByObject(filterObject);
            _common2.default.updateSearchQueryByUrl(url);
            this.showHideDialog(false);
        }
    }]);
    return AvailabilityFilter;
}();

exports.default = AvailabilityFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/availabilityFilter.js
// module id = 957
// module chunks = 0